const stateFieldPattern = /^(text|bool|number|date)(\d{2})$/;

export function isSupportedStateField(field: string): boolean {
  return stateFieldPattern.test(field);
}

export function stateXmlName(field: string): string {
  const match = stateFieldPattern.exec(field);
  // Export preflight reports this as an issue; direct serialization must also fail closed.
  if (!match) throw new Error('Unsupported state field: ' + field);
  return `State${match[2]}${({ text: 'Text', bool: 'Checkbox', number: 'Number', date: 'Date' } as Record<string, string>)[match[1]!]}`;
}
